export const playerStatuses = {
  PLAYING: 'playing',
  PAUSED: 'paused',
  STOPPED: 'stopped'
}

export const albumReleaseTypes = {
  ALBUM: 'album',
  SINGLE: 'single',
  LIVE: 'live',
  MIX: 'mix',
  COMPILATION: 'compilation'
}
